import { createContext, useReducer } from "react";
import { reducer } from "./reducer";
import { SECTIONS } from "../../constants/sections";

export const SectionContext = createContext({});

const initialState = {
  currentSection: { name: SECTIONS.HOME, element: null },
  visited: [],
};

export default function SectionContextProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <SectionContext.Provider value={{ state, dispatch }}>
      {children}
    </SectionContext.Provider>
  );
}
